import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons'
import Typography from '@mui/material/Typography'
import { formatAmount } from '../../utils/format'
import { useStyles } from './AutoSubmitLimitNote.styles'

// Mirrors `labraSupportUrl` in the host's constants; the package cannot import
// from the host.
const LABRA_SUPPORT_URL = 'https://helpcenter.labra.io/requests/new'

// TODO(funding): drop once the API reports a limit for every program.
const DEFAULT_LIMIT_USD = 5000

interface AutoSubmitLimitNoteProps {
  /** The program's own limit (`auto_submission_limit_usd`). */
  limitUsd?: string | null
  className?: string
}

/** The auto-submit limit, shared by the program rows and the confirm dialog. */
export const AutoSubmitLimitNote = ({
  limitUsd,
  className,
}: AutoSubmitLimitNoteProps) => {
  const { classes, cx } = useStyles()
  const limit = limitUsd == null ? DEFAULT_LIMIT_USD : Number(limitUsd)
  return (
    <Typography
      component="span"
      className={cx(classes.note, className)}
      data-testid="auto-submit-limit-note"
    >
      <FontAwesomeIcon icon={faCircleInfo} className={classes.icon} />
      Auto-submit is limited to ${formatAmount(limit)}, if you need to increase
      this limit please{' '}
      <a
        className={classes.supportLink}
        href={LABRA_SUPPORT_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        create a support ticket
      </a>
      . You can always submit manually without limit
    </Typography>
  )
}
